@use '@/sass/variables';

.ui__form__checkbox {
  position: relative;

  .ui__form__checkbox__custom {
    position: relative;
    border: 2px solid variables.$gray;
    border-radius: 2px;
    height: 22px;
    width: 22px;
    top: 0;
    left: 0;
    z-index: 0;

    svg {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      z-index: 2;
    }
  }

  .ui__form__checkbox__label {
    flex: 1;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  input {
    position: absolute;
    visibility: hidden;

    &:checked ~ .ui__form__checkbox__custom {
      border-color: variables.$blue;
    }
  }

  &:hover {
    input {
      &:checked ~ .ui__form__checkbox__custom {
        border-color: variables.$blue;
      }
    }

    .ui__form__checkbox__custom {
      border-color: variables.$dark-gray;
    }
  }
}
